import React from 'react';
import { Text, Button } from '@fragments';
import './styles.scss';

export default function StudioFeedback({ studio: s }) {
  const { t } = s;
  if (!s.error && !s.notice) return null;
  return <div className="studio-feedback" role={s.error ? 'alert' : 'status'}><Text.span contrast={8}>{s.error ? t(`error_${s.error}`, { defaultValue: t('error_generic') }) : s.notice}</Text.span><Button size="small" color="overlay" variant="text" onClick={() => { s.setNotice(null); s.setError(null); }}>{t('close')}</Button></div>;
}
